<div class="payments panel_wrapper">
    <div class="payments__container">
        <div  class="payments__info text-center">
            <div class="pt-4">
                <!-- <h1>30 {{'INFO.PAYMENTS.DAYS_EXPIRE' |translate}}</h1> -->
                <button *ngIf="(!company.isUsingTrial && !company.isMembershipPaid && !company.isTrialOver)" class="btn_in_color" (click)="starTrialPeriod()" type="button">{{'PAYMENT.TRIAL_PERIOD'
                    |translate}}</button>
                <h2 *ngIf="(!company.isUsingTrial && !company.isMembershipPaid && !company.isTrialOver)">{{'OR' |translate}}</h2>
                <h2 *ngIf="(company.isUsingTrial && !company.isMembershipPaid && !company.isTrialOver)">{{'PAYMENT.INFO_TRIAL' |translate}}</h2>
                <h2 *ngIf="!company.isMembershipPaid">{{'INFO.PAYMENTS.CHOOSE' |translate}}</h2>
                <h2 *ngIf="company.isMembershipPaid">{{'PAYMENT.INFO_PAYED' |translate}}</h2>
                <button *ngIf="company.isSubscribed" class="btn_in_color mt-2" (click)="unsubscribe()" type="button">cancel subscription</button>
            </div>
        </div>
        <!-- <div class="payments__item-top-right">
            <div class="discount">
                <h4 class="ribbon">-15%</h4>
                <p>{{'INFO.PAYMENTS.SUBSCRIPTION' |translate}}</p>
            </div>
        </div> -->
        <p-progressSpinner *ngIf="spinner"></p-progressSpinner>
        <div *ngIf="!company.isMembershipPaid"  class="div_grid" style="padding-right: 4px; height: 440px;overflow-y: auto;overflow-x: hidden;"
            infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000"
            (scrolled)="loadMoreMembershipPlans()" [scrollWindow]="false">

            <div *ngFor="let plan of membershipPlanList" class="vertical_component_card">
                <div class="component-list-card h-100 d-flex flex-column">
                    <div class="text-center mem_plan_text mb-2 ">
                        <label class="lbl_name">{{plan.name}}</label>
                        <label>{{currencyInfo.currencyCode}}</label>
                        <label class="lbl_price">{{plan.defaultMonthlyPrice | number}}<b> {{'PAYMENT.MONTHLY'|translate}}</b></label>
                        <label class="lbl_price">{{plan.defaultYearlyPrice | number}}<b> {{'PAYMENT.YEARLY'|translate}}</b></label>
                        <div class="min-h-title">
                            <label class="lbl_title w-100">{{plan.title}}</label>
                            <label class="lbl_desc">{{plan.description}}</label>
                        </div>
                        <label class="lbl_num">{{'BUSINESS.NUMBER_OF_VENUES'|translate}}</label>
                        <label class="lbl_num_of_ven">{{plan.minNumberOfVenues}} - {{plan.maxNumberOfVenues}}</label>
                        <div *ngFor="let country of plan.countryNames">
                            <label class="lbl_title  w-100">{{country}}</label>
                        </div>
                    </div>
                    <div class="mt-auto text-center">
                        <button id="checkout" class="btn_in_color"
                            (click)="checkoutDialog(plan,currencyInfo)"
                            type="button">{{'BUY'|translate}}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="horizontal_component_card mt-4">
            <div class="component-list-card h-100 d-flex flex-row gap-4 align-items-center justify-content-around">
                <div>
                    <h2>Enterprise</h2>
                </div>
                <div>
                    <h4>Contact us for price</h4>
                </div>
                <div class="d-flex flex-column">
                    <h5>Contact phone:</h5>
                    <p><strong>+389 21 452 2456</strong></p>
                </div>
            </div>
        </div> -->
    </div>
</div>
<div *ngIf="company.isMembershipPaid" class="bills panel_wrapper mt-1 pb-4">
    <div class="pt-3">
        <h3>{{'PAYMENT.BILLING.INFO' |translate}}</h3>
    </div>
    <div>
        <p-table *ngIf="bilingsList.length>0" [value]="bilingsList" [paginator]="true" [rows]="pagingModel.pageSize" responsiveLayout="scroll" dataKey="Id"
        [lazy]="true" (onLazyLoad)="loadBills($event)" [totalRecords]="this.totalRecordsBill"
        [showCurrentPageReport]="true" currentPageReportTemplate="{first} {{'PAYMENT.BILLING.TO' |translate}} {last} {{'PAYMENT.BILLING.OF' |translate}} {totalRecords} {{'PAYMENT.BILLING.ENTRIES' |translate}}"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>{{'PAYMENT.BILLING.NUMBER' |translate}}</th>
                    <th>{{'PAYMENT.BILLING.PRODUCT' |translate}}</th>
                    <th>{{'PAYMENT.BILLING.PRICE' |translate}}</th>
                    <th>{{'PAYMENT.BILLING.DATE' |translate}}</th>
                    <th>{{'PAYMENT.BILLING.STATUS' |translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-biling>
                <tr>
                    <td>{{biling.transactionId}}</td>
                    <td>{{biling.productName}}</td>
                    <td>{{biling.amount | number}} {{biling.currencyCode}}</td>
                    <td>{{biling.paymentDate | date}}</td>
                    <td>
                        <!-- <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-secondary"
                            (click)="deleteProduct(biling)"></button> -->
                        {{biling.status}}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td class="text-center" [attr.colspan]="columns.length" colspan="5">
                        {{'PAYMENT.BILLING.DATE' |translate}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="text-center" *ngIf="bilingsList.length==0">
            <div class="container-fluid mt-5">
                <div class="row">
                    <div class="col-12 no-items">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                            <img src="./assets/images/icons/reservations_empty@3x.png" alt="no-reservations" class="img-responsive">
                            <p class="mt-2">{{'PAYMENT.BILLING.NO_RECORDS' |translate}}</p>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
</div>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>